import Head from 'next/head'
import parse from "html-react-parser"
import Layout from '../components/layout'
import Seo from "../components/seo";
import { default as NextLink } from "next/link";
import Moment from "react-moment";
import { Link, Box, Text, AspectRatio } from "@chakra-ui/react";
import {
    PostArticle,
    PostTitle,
    PostMeta,
    FeatImage,
    ArticleBody,
  } from "../styles/postStyles";
  import { postOptions } from "../lib/parseOptions";

const PageTemplate = ( { post, menus }) => {
    return (
        <Layout menus={menus}>
            <Head><title>{post.title}</title></Head>
            <PostArticle
        className="page-body"
        itemScope
        itemType="http://schema.org/Event"
      >
        <header>
          <PostTitle as="h1" textAlign="left" px={8} itemProp="headline">
            {parse(post.title)}
          </PostTitle>
        </header>

        {!!post.content && (
          <ArticleBody p={8} itemProp="articleBody">
            {parse(post.content, postOptions)}
          </ArticleBody>
        )}

        <hr />
      </PostArticle>
        </Layout>
    )
}

export default PageTemplate
